<div class="card bg-card-new card-radius-x1 border-0" >
    <div class="card-header">
        <h5>{{"quotation_requests"|translate}}</h5>
    </div>
    <div class="card-divider"></div>
    <div class="card-table">
        <div class="table-responsive-sm">
            <table>
                <thead>
                <tr>
                    <th>{{"email"|translate}}</th>
                    <th>{{"date"|translate}}</th>
                    <th>{{"status"|translate}}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let request of requests" [routerLink]="'/account/quotation-requests/' + request._id" class="cursor:pointer">
                    <td><a [routerLink]="'/account/quotation-requests/' + request._id">#{{ request.email }}</a></td>
                    <td>{{ request.requestDate |date }}</td>
                    <td [style.color]="status[request.status]?.color"> {{status[request.status]?.text }} </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div *ngIf="paginationOrderCount > 1">
        <div class="card-divider"></div>
        <div class="card-footer">
            <app-pagination (pageChange)="updateOrdersList($event)"  [total]="paginationOrderCount"></app-pagination>
        </div>
    </div>
</div>
